import { render, staticRenderFns } from "./PainelComiteGovernancaDigital.vue?vue&type=template&id=2aa20613"
import script from "./PainelComiteGovernancaDigital.vue?vue&type=script&lang=js"
export * from "./PainelComiteGovernancaDigital.vue?vue&type=script&lang=js"
import style0 from "./PainelComiteGovernancaDigital.vue?vue&type=style&index=0&id=2aa20613&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports